<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <div class="grid grid-cols-12 pt-4 container">
            <div class="col-span-12 md:col-span-4">
                <ButtonTag
                    :is-tw-main-btn="true"
                    v-if="canManagerSuppliers()"
                    url="suppliers/add"
                >
                    <div class="pt-1">
                        {{ $t('supplier.add') }}
                    </div>
                </ButtonTag>
            </div>

            <div class="col-span-5">

            </div>

            <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-3 position-relative mt-4 mt-md-0">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                    <span>
                        {{ $t('supplier.ourTotalDebt') }}:
                    </span>
                </div>
                <div class="pt-2 pl-3 font-bold text-gray-500">
                    <span class="text-primary">
                        {{ showCurrencyById(3, getCompanyRemaining.ourDebt) }}
                    </span>
                </div>
            </div>
        </div>

        <div class="container">
            <SearchCollapse class="pt-4" :is-bg-white="true" :do-action="showCheckboxes">
                <div class="grid grid-cols-12 gap-3">
                    <div class="col-span-12 md:col-span-3 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-10 ml-2">
                            {{ $t('person.givenName') }}
                        </div>
                        <b-form-input
                            v-model="search.givenName"
                            class="focus:ring-0 border-gray-300 h-11"
                            @keyup.enter="searchSuppliers"
                        >
                        </b-form-input>
                    </div>
                    <div class="col-span-12 md:col-span-3 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-10 ml-2">
                            {{ $t('person.familyName') }}
                        </div>
                        <b-form-input
                            v-model="search.familyName"
                            class="focus:ring-0 border-gray-300 h-11"
                            @keyup.enter="searchSuppliers"
                        >
                        </b-form-input>
                    </div>
                    <div class="col-span-12 md:col-span-3 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-10 ml-2">
                            {{ $t('company.name') }}
                        </div>
                        <b-form-input
                            v-model="search.companyName"
                            class="focus:ring-0 border-gray-300 h-11"
                            @keyup.enter="searchSuppliers"
                        >
                        </b-form-input>
                    </div>
                    <div class="col-span-12 md:col-span-3">
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-11 w-50 focus:outline-none">
                            <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchSuppliers">
                        </button>
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-11 w-50 focus:outline-none">
                            <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetSupplierSearchInfo">
                        </button>
                    </div>
                </div>
            </SearchCollapse>
        </div>
        <RowColumn>
            <TableTag
                class="w-full"
                getter-name="getSuppliers"
                fetch-getter-name="fetchSuppliersTotalCredit"
                :headers="headers"
                :body-properties="bodyProperties"
                :isSelectable=true
            >
                <template v-slot:custom="row">
                    <router-link :to="$i18nHelper.getUrl('suppliers/' + row.item.id)" style="color: #069F43">
                        {{
                            row.item.isCompany ? row.item.supplierCompany.name : row.item.person.givenName + ' ' + row.item.person.familyName
                        }}
                    </router-link>
                </template>
                <template v-slot:telephone="row">
                    <span v-if="row.item.isCompany">
                        <span v-if="row.item.supplierCompany.telephone !== null">{{
                                row.item.supplierCompany.telephone
                            }}</span>
                    </span>
                    <span v-else>
                        <span v-if="row.item.person.telephone !== null">{{ row.item.person.telephone }}</span>
                    </span>
                </template>
                <template v-slot:actions="row">
                    <span class="d-flex float-right mr-3">
                        <img src="/images/edit.png" alt="" class="h-5 mt-1 cursor-pointer pr-3" @click="$i18nHelper.toUrl('suppliers/' + row.item.id)">

                        <img src="/images/Union.png" alt="" class="h-6 mt-0.5 cursor-pointer" @click="$bvModal.show('delete-supplier-' + row.item.id)">
                    </span>
                    <Modal
                        text="deleteConfirm"
                        ok-text="yes"
                        cancel-text="no"
                        :is-ok-only="false"
                        :context="{name: row.item.isCompany ? row.item.supplierCompany.name : row.item.person.givenName + ' ' + row.item.person.familyName}"
                        :id="'delete-supplier-' + row.item.id"
                        :on-ok-pressed="() => {deleteOneSupplier(row.item.id)}"
                    />
                </template>
                <template v-slot:checkboxes="row" v-if="canSeeSupplierDebts()">
                    <b-form-checkbox
                        class="-mr-2"
                        v-if="isShowCheckbox"
                        size="lg"
                        @change="getId(row.item)"
                        :value=row.item.id
                        v-model="selectedSuppliers"
                    />
                </template>
                <template v-slot:checkAll_0 v-if="canSeeSupplierDebts()">
                    <b-form-checkbox
                        class="-mr-2"
                        v-if="isShowCheckbox"
                        size="lg"
                        @change="selectAll"
                        v-model="isSelectedAll"
                    />
                </template>
            </TableTag>
            <div>
                <b-button
                    variant="danger"
                    size="sm"
                    v-if="selectedSuppliers.length > 0"
                    style="background-color: red; color: #fff"
                    class="d-flex float-right mx-2"
                    @click="showModal">
                    {{ $t('delete') }}
                </b-button>
            </div>
            <div class="clear">
            </div>
            <b-modal id="delete-Supplier-modal" hide-footer>
                <!-- Modal body -->
                <div class="modal-body">
                    {{ $t('supplier.deleteSupplierWarning') }}
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn danger" data-dismiss="modal" @click="deleteSuppliers">
                        {{ $t('yes') }}
                    </button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" @click="cancelDelete">
                        {{ $t('no') }}
                    </button>
                </div>
            </b-modal>

            <b-modal
                :hide-header="true"
                footer-class="p-2 border-top-0 d-flex justify-content-between"
                id="delete"
            >

                <template #default="{}">
                    <h5 style="text-align: center">{{ $t('supplier.hasDebts') }}</h5>
                </template>

                <template #modal-footer="{ ok, cancel }">
                    <b-button variant="success" @click="cancel()">
                        {{ $t('cancelDelete') }}
                    </b-button>
                    <b-button variant="danger" @click="deleteOneSupplier(supplierId); ok()">
                        {{ $t('customer.deleteAnyway') }}
                    </b-button>
                </template>
            </b-modal>
        </RowColumn>

        <div class="container mt-4">
            <PaginationRow
                :search="search"
                base-url="supplier"
                method-name="searchSupplier"
                :total-items="getSuppliersTotalCount"
            />
        </div>

    </Row>
</template>

<script>
import Row from "../../components/html/Row";
import RowColumn from "../../components/RowColumn";
import {mapActions, mapGetters} from "vuex";
import ButtonTag from "../../components/html/ButtonTag";
import TableTag from "../../components/html/TableTag";
import PaginationRow from "@/components/PaginationRow";
import accessMixin from "@/mixin/accessMixin";
import Modal from "../../components/html/Modal";
import SearchCollapse from "@/components/SearchCollapse";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";


export default {
    name: "List",
    mixins: [accessMixin, currencyFormatMixin],
    data() {
        return {
            supplierId: null,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'supplier.title'},
            ],
            search: {
                givenName: '',
                familyName: '',
                companyName: '',
                page: 1
            },
            headers: [
                {name: 'id', hideOnMobile: true},
                {name: 'name'},
                {name: 'company.telephone'},
                {name: 'actions'}
            ],
            bodyProperties: [
                {
                    name: 'id', bgWarning: this.isBgColorWarning, bgDanger: function () {
                    }, hideOnMobile: true
                },
                {
                    name: 'custom', bgWarning: this.isBgColorWarning, bgDanger: function () {
                    },
                },
                {
                    name: 'telephone', bgWarning: this.isBgColorWarning, bgDanger: function () {
                    },
                },
                {
                    name: 'actions', bgWarning: this.isBgColorWarning, bgDanger: function () {
                    },
                }
            ],
            isShowCheckbox: false,
            selectedSuppliers: [],
            isCheckedAll: false,
            isSelectedAll: false,
        }
    },
    computed: {
        ...mapGetters([
            'getCompanyRemaining',
            'getSupplier',
            'getSuppliersTotalCount',
            'getSuppliers',
            'getSupplierFee'
        ])
    },
    methods: {
        ...mapActions([
            'deleteSupplier',
            'fetchSuppliers',
            'searchSupplier',
            'fetchSupplierFee',
            'fetchCompanyRemaining',
            'fetchUser',
            'setBreadcrumbItems'
        ]),
        showModal() {
            if (this.selectedSuppliers.length > 0) {
                this.$bvModal.show('delete-Supplier-modal')
            }
        },
        showCheckboxes() {
            if (this.isShowCheckbox) {
                this.headers.shift()
                this.bodyProperties.shift()
            } else {
                this.headers.unshift({name: ''})
                this.bodyProperties.unshift({
                    name: 'checkboxes',
                    bgWarning: this.isBgColorWarning,
                    bgDanger: function () {
                    }
                })
            }

            this.isShowCheckbox = !this.isShowCheckbox

            if (this.selectedSuppliers.length > 0) {
                this.selectedSuppliers = []
                this.isCheckedAll = false
                this.isSelectedAll = false
            }
        },
        getId(custom) {
            let hasCustomId = this.selectedSuppliers.some(function (item) {
                return item === custom.id
            })

            if (hasCustomId) {
                let index = this.selectedSuppliers.indexOf(custom.id)
                this.selectedSuppliers.splice(index, 1)
            } else {
                this.selectedSuppliers.push(custom.id)
            }
        },
        async deleteSuppliersAction() {
            this.selectedSuppliers.forEach(sale => {
                console.log(sale)
                this.modalOk(sale)
            })
        },
        deleteSuppliers() {
            this.$root.showOverlay = true

            this.deleteSuppliersAction()
                .then(() => {
                    this.selectedSuppliers = []
                    this.$bvModal.hide('delete-Supplier-modal')
                    this.isCheckedAll = false
                })
                .finally(() => {
                    setTimeout(this.updateSuppliers, 1000)
                })
        },
        updateSuppliers() {
            this.fetchSuppliersTotalCredit(this.$route.params.page)
            this.$root.showOverlay = false
        },
        cancelDelete() {
            this.$bvModal.hide('delete-Supplier-modal')
            this.selectedSuppliers = []
            this.isCheckedAll = false
        },
        selectAll() {
            if (this.isSelectedAll) {
                this.selectedSuppliers = []
                this.isSelectedAll = false
            } else {
                this.getSuppliers.forEach(supplier => {
                    this.selectedSuppliers.push(supplier.id)
                })

                this.isSelectedAll = true
            }
        },
        isBgColorWarning(item) {
            return this.hasDebts(item)
        },
        hasDebts(item) {
            return item.totalDebt !== 0 || item.debt > 0
        },
        deleteOneSupplier(id) {
            this.$root.showOverlay = true

            this.deleteSupplier(id)
                .then(() => {
                    this.searchSupplier(this.search)
                        .then(() => {
                            this.$root.showOverlay = false
                        })
                })
        },
        getItemName(item) {
            return item.isCompany ? item.supplierCompany.name : item.person.givenName + ' ' + item.person.familyName
        },
        getSupplierName(item) {
            return item.supplier.isCompany ?
                item.supplier.supplierCompany.name :
                item.supplier.person.givenName + ' ' + item.supplier.person.familyName
        },
        modalOk(id) {
            this.$root.showOverlay = true

            this.fetchSupplierFee(id)
                .then(() => {
                    if (this.getSupplierFee.ourDebt > 0) {
                        console.log(this.getSupplierFee.ourDebt, 'debt')
                        this.supplierId = id
                        this.$bvModal.show('delete')
                        this.$root.showOverlay = false
                    } else {
                        this.deleteOneSupplier(id)
                    }
                })
        },
        searchSuppliers() {
            this.$root.showOverlay = true
            this.searchSupplier(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        resetSupplierSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchSuppliers()
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    async mounted() {
        if (this.getUserCompany.id === null) {
            await this.fetchUser()
        }
        await this.fetchCompanyRemaining()
    },
    components: {
        TableTag,
        ButtonTag,
        RowColumn,
        Row,
        PaginationRow,
        Modal,
        SearchCollapse,
    },
}
</script>
<style scoped>
.form-control {
    margin-bottom: 5px !important;
}

.mb-3 {
    margin-bottom: -16px !important;
}

.btn-danger {
    background-color: red;
}
</style>
